/**
 * Service Worker cleanup — unregisters any previously installed SW.
 *
 * ScholarVision previously used a caching service worker (sw.js) for offline
 * support. The cache-first strategy for /assets/* conflicted with Vite's
 * content-hashed deploys, causing stale chunk errors after each deploy.
 *
 * We now rely on:
 *   - Cloudflare Pages CDN for asset caching
 *   - public/_headers for Cache-Control directives
 *   - lazyRetry() in App.tsx for chunk-load resilience
 *
 * This function ensures any lingering service worker from before the change
 * is cleanly removed. The stub sw.js in public/ handles the cache cleanup;
 * this function handles the registration side.
 */
export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
  } catch {
    // Silently ignore — the user just won't get the cleanup
  }
}
